import pkFBRSaleEndorsementHandler from './pakistan/fbr/saleEndorsementHandler';
import pkSRBSaleEndorsementHandler from './pakistan/srb/saleEndorsementHandler';
import keKRASaleEndorsementHandler from './kenya/kra/saleEndorsementHandler';

const terminalUtility = require('../../terminalUtility');

const externalIntegrationUtils = require('../externalIntegrationUtils');
const logger = require('../../../logger/logger');

const integrationTypes = externalIntegrationUtils.integrationTypes;
const externalEntities = externalIntegrationUtils.externalEntities;

export async function applySaleEndorsements(sale)
{
    try
    {
        sale.endorsements = sale.endorsements || [];

        const integrations = terminalUtility.getTerminalIntegrations()
                                          .filter(integration => integration.isEnabled && integration.integrationType === integrationTypes.saleEndorsement);

        for (const integration of integrations)
        {
            await applySaleEndorsement(sale, integration);
        }
    }
    catch (error)
    {
        logger.error(`Error occurred while applying sale endorsements: ${error}`, {}, error);
    }
}

export async function applyDeferredEndorsements(sale)
{
    try
    {
        var applied = false;

        if (sale.endorsements == null || sale.endorsements.length <= 0)
            return applied;


        for (const endorsement of sale.endorsements)
        {
            if (await applyDeferredEndorsement(sale, endorsement))
                applied = true;
        }

        return applied;
    }
    catch (error)
    {
        logger.error(`Error occurred while applying sale endorsements. ${error}`, {}, error);
    }
}

async function applyDeferredEndorsement(sale, endorsement)
{
    var applied = false;

    if (endorsement.isError || !endorsement.isDeferred)
        return applied;

    const integration = terminalUtility
                                    .getTerminalIntegrations()
                                    .find(integration => integration.id === endorsement.integrationId);

    if (integration == null) return applied;
    const endorsementHandler = getSaleEndorsementHandler(sale, integration);
    if (endorsementHandler == null) return applied;

    const newEndorsement = await endorsementHandler.getSaleEndorsement(sale, integration);
    if (newEndorsement == null) return applied;
    if (newEndorsement.isError) return applied;

    const index = sale.endorsements.findIndex(e => e === endorsement);

    if (index > -1)
    {
        // Replace existing deferred endorsement with the new permanent endorsement
        sale.endorsements.splice(index, 1, newEndorsement);
        applied = true;
    }

    return applied;
}

async function applySaleEndorsement(sale, integration)
{
    try
    {
        const endorsementHandler = getSaleEndorsementHandler(sale, integration);

        if (endorsementHandler != null) 
        {
            await endorsementHandler.applySaleEndorsement(sale, integration);
        }
    }
    catch (error)
    {
        logger.error(`Error occurred while applying sale endorsement integration: ${integration.integrationType}/${integration.externalEntity}: ${error}`, {}, error);
    }
}

function getSaleEndorsementHandler(sale, integration)
{
    switch (integration.externalEntity)
    {
        case externalEntities.saleEndorsement.pkFBR:
            return pkFBRSaleEndorsementHandler;

        case externalEntities.saleEndorsement.pkSRB:
            return pkSRBSaleEndorsementHandler;

        case externalEntities.saleEndorsement.keKRA:
            return keKRASaleEndorsementHandler;

        default:
            return null;
    }
}
